import PropTypes from 'prop-types';
import React from 'react';
import StyledCheckbox from './checkbox.style';
import CheckboxIcon from '../../icons/checkbox/checkbox';
import MixedCopy from '../../molecules/mixed-copy/mixedCopy';

const Checkbox = ({
  label,
  name,
  required = false,
  onFocus,
  onBlur,
  onChange,
  error = false,
  disabled = false,
  active,
  warning,
  copy,
  checked
}) => (
  <StyledCheckbox disabled={disabled} error={error} active={active}>
    <label htmlFor={name} className="checkbox__wrapper">
      <input
        id={name}
        name={name}
        type="checkbox"
        onFocus={onFocus}
        onBlur={onBlur}
        onChange={onChange}
        aria-invalid={error}
        disabled={disabled}
        checked={checked}
      />
      <span className="checkbox__custom-checkbox">
        <CheckboxIcon />
      </span>
      <span className="checkbox__label">
        {required && <span className="checkbox__required">*</span>}
        <MixedCopy className="checkbox__labelText" html={label} />
        {copy && <MixedCopy html={copy} className="checkbox__copy" />}
      </span>
    </label>
    {warning && (
      <span className="checkbox__warn" aria-hidden={!error}>
        {warning}
      </span>
    )}
  </StyledCheckbox>
);

Checkbox.propTypes = {
  name: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  required: PropTypes.bool,
  onChange: PropTypes.func,
  onFocus: PropTypes.func,
  onBlur: PropTypes.func,
  active: PropTypes.bool,
  warning: PropTypes.shape(),
  error: PropTypes.bool,
  disabled: PropTypes.bool,
  copy: PropTypes.string,
  checked: PropTypes.bool
};

export default Checkbox;
